import { FC } from 'react';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';
import Spinner from '@raydiant/raydial/components/Spinner';

interface PlaylistHeaderV2Props {
  onSave?: () => void;
  isSaveDisabled?: boolean;
  isSaving?: boolean;
}

const PlaylistHeaderV2: FC<PlaylistHeaderV2Props> = ({
  onSave,
  isSaveDisabled,
  isSaving,
}) => {
  return (
    <Button
      className="w-[156px] h-14 px-4 py-5 rounded-2xl bg-blue-600 disabled:bg-gray-600"
      aria-label={isSaving ? 'Saving...' : 'Save'}
      variant="primary"
      isDisabled={isSaveDisabled || isSaving}
      onPress={onSave}
    >
      <div className="flex text-white items-center gap-2">
        {isSaving && <Spinner size="small" className="text-white" />}
        <Text className="normal-case" variant="largeSubtitle">
          {isSaving ? 'Saving...' : 'Save'}
        </Text>
      </div>
    </Button>
  );
};

export default PlaylistHeaderV2;
